import { isoLanguages } from "../../resources/isoLanguages.ts";
import type { EnumDefinition, EnumItemBase, EnumValues } from "../index.ts";
import { projectName } from "../projectName.ts";

export type LanguageItem = EnumItemBase & {
  char2Code: string;
  char3Code: string;
  name: string;
};

export type Language = EnumValues<typeof languageEnum>;

export const languageEnum = {
  header: {
    businessName: "Language",
    businessOwner: "Core team",
    dataSource: "Internal",
    description: "List of languages by ISO 639-1 standard",
    scopeOfUsage: "Shared",
    technicalName: "language",
    projectName,
    additionalAttributes: {
      char2Code: {
        dataSource: "Internal",
        description: "2-letter ISO 639-1 code",
      },
      char3Code: {
        dataSource: "Internal",
        description: "3-letter ISO 639-3 code",
      },
      name: {
        dataSource: "Internal",
        description: "Language name",
      },
    },
  },
  values: isoLanguages.map((item) => {
    return {
      value: item.char2Code,
      valueUsage: "CanBeEntered",
      char2Code: item.char2Code,
      char3Code: item.char3Code,
      name: item.name,
    } satisfies LanguageItem;
  }),
} as const satisfies EnumDefinition<LanguageItem>;

export type FrontEndLanguageItem = EnumItemBase & {
  sortKey: number;
};

export const FE_SUPPORTED_LANGUAGES = [
  "cs",
  "en",
] as const satisfies readonly Language[];

export type FrontEndLanguage = (typeof FE_SUPPORTED_LANGUAGES)[number];

export const frontEndLanguageEnum = {
  header: {
    businessName: "Front-end Language",
    businessOwner: "Core team",
    dataSource: "Internal",
    description: "Languages which can user use on the front-end",
    scopeOfUsage: "Shared",
    technicalName: "frontEndLanguage",
    projectName,
    additionalAttributes: {
      sortKey: {
        dataSource: "Internal",
        description: "Sorting key for ordering",
      },
    },
  },
  values: isoLanguages
    .filter((lang) =>
      (FE_SUPPORTED_LANGUAGES as readonly string[]).includes(lang.char2Code),
    )
    .map((item, index) => {
      return {
        value: item.char2Code as FrontEndLanguage,
        valueUsage: "CanBeEntered" as const,
        sortKey: index,
      };
    }),
} as const satisfies EnumDefinition<FrontEndLanguageItem>;
